import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

const Dropdown = ({ title, icon, items }) => {
  return (
    <div>
      <Menu as="div" className="relative inline-block">
        <div>
          <Menu.Button className="inline-flex justify-center w-full px-4 py-2 text-sm rounded-md">
            {title}
            {icon}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="z-20 absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
            {items.map((item, key) => (
              <div key={key} className="px-1 py-1">
                {item.map((sub_item, sub_key) => (
                  <Menu.Item key={sub_key}>
                    <button
                      disabled={sub_item.is_disabled}
                      onClick={() => sub_item.action()}
                      className="group flex rounded-md items-center w-full p-2 text-sm disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {sub_item.icon}
                      {sub_item.name}
                    </button>
                  </Menu.Item>
                ))}
              </div>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default Dropdown;
